import React, { PureComponent } from 'react'
import { shape } from 'prop-types'

import Signin from '../../components/Signin'
import Signup from '../../components/Signup'
import ForgotPassword from '../../components/ForgotPassword'
import processBuilder from '../../shared/utils/processBuilder'

import { signInUpServiceConfig } from '../shared/config'
import injectWidget from '../shared/injectWidget'

const PROCESS_MAPPING = {
  signIn: Signin,
  signUp: Signup,
  forgotPassword: ForgotPassword,
}

class SignInUpWidget extends PureComponent {
  static propTypes = {
    showComponent: shape({}).isRequired,
  }

  constructor(props) {
    super(props)
    const { showComponent } = props
    this.processes = processBuilder(PROCESS_MAPPING, (Process, processProps = {}) => {
      this.setState({ Process, processProps })
    })
    this.state = {
      Process: showComponent,
    }
  }

  render() {
    const { ...rest } = this.props
    const { Process, processProps } = this.state
    return (
      <Process
        {...rest}
        {...processProps}
        processes={this.processes}
      />
    )
  }
}

export default injectWidget({
  widget: SignInUpWidget,
  serviceConfig: signInUpServiceConfig,
})
